import React, {Component} from 'react';
import UserAttributesCell from "./UserAttributesCell";
import {PropTypes} from 'prop-types';
import UserAttributesEnum from "./UserAttributesEnum";
import * as messageConstants from '../../../shared/messages';

class UserAttributesRow extends Component {

  static propTypes = {
    userAttribute: PropTypes.any,
    onUserAttributesTableUpdate: PropTypes.func,
    onRowDel: PropTypes.func,
    rowIndex: PropTypes.any,
  }
  handleOnUserAttributesTableUpdate = (e) => {
    this.props.onUserAttributesTableUpdate(e);
  }

  onDelEvent() {
    this.props.onRowDel(this.props.userAttribute);
  }

  render() {
    return (
        <tr>
          <td className="pb-12">
            <UserAttributesCell
                className="attributes-name-input form-control attributes-input"
                onUserAttributesTableUpdate={this.handleOnUserAttributesTableUpdate}
                cellData={{
                  type: "userAttributeName",
                  value: this.props.userAttribute.userAttributeName,
                  id: this.props.id,
                  placeholder: messageConstants.ATTRIBUTE_NAME
                }}/>
          </td>
          <td className="pl-12 pb-12">
            <UserAttributesEnum
                onUserAttributesTableUpdate={this.handleOnUserAttributesTableUpdate}
                displayFlexibleAttributes={this.props.displayFlexibleAttributes}
                displayUserExtendedAttributes={this.props.displayUserExtendedAttributes}
                extendedAttributes={this.props.extendedAttributes}
                cellData={{
                  type: "idpUserAttributeEnum",
                  value: this.props.userAttribute.idpUserAttributeEnum,
                  id: this.props.id
                }}/>
          </td>
          <td className="pl-12 pb-12">
            {this.props.userAttribute.idpUserAttributeEnum.toString()
            === "CUSTOM_ATTRIBUTE" ? <UserAttributesCell
                className="attributes-custom-value-input form-control attributes-input"
                onUserAttributesTableUpdate={this.handleOnUserAttributesTableUpdate}
                cellData={{
                  type: "userSpecifiedValue",
                  value: this.props.userAttribute.userSpecifiedValue,
                  id: this.props.id,
                  placeholder: messageConstants.VALUE
                }}/> : <div className="attributes-custom-value-input"/>}
          </td>
          <td className="pl-12">
            <div className="remove-attribute-col">
              <button type="button" onClick={this.onDelEvent.bind(this)}
                      className="attr-button dell-button">
                <span className="fa fa-minus btn-circle btn-minus"/>
                <span
                    className="attr-button-label">{messageConstants.BUTTON_REMOVE_ATTRIBUTE}
                </span>
              </button>
            </div>
          </td>
        </tr>
    );

  }

}

export default UserAttributesRow;